<form (ngSubmit)="save()" [formGroup]="form">
	<div [alarisLoading]="service.loading$">
		<div class="edit-panel-header">
			<alaris-icon name="icon-add-contact"></alaris-icon>
			{{ code.id ? ('system_codes.edit' | translate) : ('system_codes.add' | translate) }}
		</div>
		<div [alarisFade]="'vertical'" class="form-group panel-content">
			<alaris-input formControlName="value" [errors]="errors">
				{{ 'system_codes.code_value' | translate }}
			</alaris-input>

			<alaris-text-area formControlName="description" [errors]="errors">
				{{ 'system_codes.code_description' | translate }}
			</alaris-text-area>

			<button (click)="reset()" alaris-button bType="secondary" class="reset-button" size="lg" type="button">
				<alaris-icon name="icon-refresh-clock-wise"></alaris-icon>
				{{ 'gl.reset' | translate }}
			</button>
		</div>
		<div class="edit-panel-footer">
			<button [disabled]="form.invalid || !form.dirty" alaris-button bType="primary" size="lg"
				type="submit">
				<alaris-icon class="in-primary" name="icon-success"></alaris-icon>
				{{ 'gl.submit' | translate }}
			</button>
			<button (click)="close()" alaris-button bType="outline" size="lg" type="button">
				{{ 'actions.close' | translate }}
			</button>
		</div>
	</div>
</form>